import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyHead, headForPath } from './documentHead';

/**
 * Resets title/description/canonical on every navigation. Render it before the
 * route tree: its effect then runs ahead of the page's own effects, so pages
 * that refine their head (detail pages, the 404 page) win.
 */
const RouteHead: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    applyHead(headForPath(pathname));
  }, [pathname]);
  return null;
};

export default RouteHead;
